import { useSelector, shallowEqual } from 'react-redux';
import State from 'store/State';

export function useShallowEqualSelector<T>(selector: (state: State) => T) {
    return useSelector(selector, shallowEqual);
}
